import React from 'react';
import './Popular.css';

const Popular = () => {
    return (
        <div className='relative top-80 md:top-40'>
        </div>
    );
};

export default Popular;